import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Container,
  Message,
} from 'semantic-ui-react';
import { resetFlashMessage } from '../actions/flash';

class Flash extends Component {
  constructor(props) {
    super(props);
    this.timer = null;
    this.state = {
      visible: false,
    };
  }
  componentWillReceiveProps(nextProps) {
    const { flash } = nextProps;
    if (flash) {
      const visible = flash.show;
      this.clearTimer();
      this.setState({
        visible,
      }, () => {
        if (flash.autoHideDuration > 0) {
          if (visible) {
            this.timer = setTimeout(() => {
              this.close();
            }, flash.autoHideDuration);
          }
        }
      });
    }
  }
  componentWillUnmount() {
    this.clearTimer();
  }
  clearTimer() {
    clearTimeout(this.timer);
  }
  close() {
    this.clearTimer();
    this.setState({
      visible: false,
    }, () => {
      setTimeout(
        () => {
          const { store } = this.context;
          store.dispatch(resetFlashMessage());
        }, 600);
    });
  }
  handleDismiss = () => {
    this.close();
  }
  render() {
    const { flash } = this.props;
    return (
      <Container className={`flash ${this.state.visible ? 'show' : ''}`}>
        <Message
          onDismiss={this.handleDismiss}
          header={flash.header}
          content={flash.message}
          list={flash.list}
          icon={flash.icon}
          color={flash.color && !flash.type ? flash.color : null}
          error={flash.type === 'error'}
          info={flash.type === 'info'}
          negative={flash.type === 'negative'}
          positive={flash.type === 'positive'}
          success={flash.type === 'success'}
          warning={flash.type === 'warning'}
        />
      </Container>
    );
  }
}

Flash.propTypes = {
  flash: PropTypes.shape({
    header: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node,
    ]),
    message: PropTypes.string,
    list: PropTypes.arrayOf(PropTypes.string),
    icon: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
    color: PropTypes.string,
    type: PropTypes.string,
    show: PropTypes.bool,
    autoHideDuration: PropTypes.number,
  }),
};

Flash.contextTypes = {
  store: PropTypes.object,
};

const mapStateToProps = state => ({
  flash: state.flash,
});

export default connect(mapStateToProps)(Flash);



// WEBPACK FOOTER //
// ./src/components/Flash.jsx